/** PHKL Custom -s
 *  Only for phkl GA
 * */

export const PHKLGetShortForm = (str?: string): string => {
  if (!str) return "";
  let output = str.replace(/\s/g, "_");
  if (output.length > 4) {
    output = `${output.substring(0, 2)}${output.substring(output.length - 2, output.length)}`;
  }
  return `_${output.toUpperCase()}`;
};

// PHKL Custom -e
